<template>
  <div class="drawer-box">
    <h1 class="title" v-html="details.title"></h1>
    <div class="release-box">
      <div>发布时间：{{ details.createTime }}</div>
      <!-- <div>创建人：{{details.createUser}}</div> -->
      <div>创建人：{{ details.createUserName }}</div>
    </div>
    <div class="column">
      <span :class="['tab', isTab === 1 ? 'is-tab' : '']" @click="isTab = 1"
        >基本信息</span
      >
      <span :class="['tab', isTab === 2 ? 'is-tab' : '']" @click="changeTab(2)"
        >参会人员</span
      >
      <span :class="['tab', isTab === 3 ? 'is-tab' : '']" @click="changeTab(3)"
        >会议图片</span
      >
      <span :class="['tab', isTab === 4 ? 'is-tab' : '']" @click="changeTab(4)"
        >会议视频</span
      >
    </div>
    <div class="drawer-content-box" style="position: relative">
      <div class="drawer-content" v-if="isTab === 1">
        <div class="item">
          <span class="label">会议类型：</span>
          <span class="content">{{
            details.meetingType === 1 ? "线上会议" : "线下会议"
          }}</span>
        </div>
        <div class="item">
          <span class="label">会议主图：</span>
          <img
            class="content-img"
            v-lazy="$global.imgUrl + details.cover"
            alt=""
          />
        </div>
        <div class="item">
          <span class="label">会议时间：</span>
          <span class="content"
            >{{ details.beginTime }} - {{ details.endTime }}</span
          >
        </div>
        <div class="item">
          <span class="label">会议地点：</span>
          <span class="content" v-if="details.meetingType === 2"
            >{{ details.province }} - {{ details.city }}
            <span v-if="details.address">- {{ details.address }}</span>
          </span>
          <span class="content" v-else>{{ details.address }}</span>
        </div>
        <div class="item">
          <span class="label">主办单位：</span>
          <span class="content"
            ><span
              class="more-auther"
              v-for="item in details.organizerList"
              :key="item.orgId"
              >{{ item.name }}</span
            ></span
          >
        </div>
        <div class="item" v-if="details.undertakerList.length > 0">
          <span class="label">承办单位：</span>
          <span class="content"
            ><span
              class="more-auther"
              v-for="item in details.undertakerList"
              :key="item.orgId"
              >{{ item.name }}</span
            ></span
          >
        </div>
        <div class="item" v-if="details.coOrganizerList.length > 0">
          <span class="label">协办单位：</span>
          <span class="content"
            ><span
              class="more-auther"
              v-for="item in details.coOrganizerList"
              :key="item.orgId"
              >{{ item.name }}</span
            ></span
          >
        </div>
        <div class="item" v-if="details.periodicals.length > 0">
          <span class="label">合作期刊：</span>
          <span class="content"
            ><span
              class="more-auther"
              v-for="item in details.periodicals"
              :key="item.perId"
              >{{ item.perName }}</span
            ></span
          >
        </div>
        <div class="item">
          <span class="label">标签：</span>
          <span class="content">{{ details.keyword }}</span>
        </div>
        <div class="item" v-if="details.artSummary">
          <span class="label">摘要：</span>
          <span class="content">{{ details.artSummary }}</span>
        </div>
        <div class="item">
          <span class="label">会议内容：</span>
          <span class="content" v-html="details.content"></span>
        </div>
        <div class="item" v-if="(details.edits && details.edits.length > 0) || details.solicitContent">
          <span class="label">征稿信息：</span>
          <div class="content">
            <div v-if="details.edits.length > 0">
              <h4>征稿采编</h4>
              <div
                style="color: #333; margin-bottom: 10px"
                v-for="(item, index) in details.edits"
                :key="index"
              >
                <span style="font-size: 18px">{{ item.userName }}</span>
                <span style="font-size: 14px">({{ item.post }})</span>
                <span style="margin-left: 30px; font-size: 14px"
                  >联系方式：{{ item.phone }}</span
                >
              </div>
            </div>
            <div v-if="details.solicitContent">
              <h4>征稿信息</h4>
              <div v-html="details.solicitContent"></div>
            </div>
          </div>
        </div>
        <div class="item" v-if="details.committees.length > 0">
          <span class="label">组委会信息：</span>
          <div class="content">
            <div
              class="committee"
              v-for="item in details.committees"
              :key="item.id"
            >
              <img
                v-if="item.headImg"
                :src="$global.imgUrl + item.headImg"
                style="width: 64px; height: 64px; border-radius: 50%"
                alt=""
              />
              <Big
                v-else
                width="64"
                height="64"
                size="20"
                :big="item.userName"
              />
              <div style="margin-left: 10px">
                <p>
                  <span style="font-size: 24px; margin-right: 24px">{{
                    item.userName
                  }}</span>
                  <span
                    style="color: #666666"
                    v-for="i in item.titles"
                    :key="i.id"
                    >{{ i.levelTwo }}</span
                  >
                </p>
                <p>
                  <span
                    v-if="item.unit"
                    style="font-size: 16px; margin-right: 50px"
                    >{{ item.unit }}</span
                  >
                  <span style="color: #666" v-if="item.researchDirection"
                    >研究方向：{{ item.researchDirection }}</span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="item" v-if="details.contactsName && details.contactsInfo">
          <span class="label">会议联系人：</span>
          <span class="content"
            >{{ details.contactsName }} {{ details.contactsInfo }}</span
          >
        </div>

        <div class="item">
          <span class="label">开启报名：</span>
          <span class="content">{{
            details.open === 1 ? "开启" : "关闭"
          }}</span>
        </div>

        <div class="item" v-if="details.open === 1">
          <span class="label">门票信息：</span>
          <div class="content">
            <Table :columns="tickeColumns" :data="details.tickets">
              <template slot-scope="{ row }" slot="date">
                <div>
                  {{ row.beginTime.slice(0, 10) }}-{{
                    row.endTime.slice(0, 10)
                  }}
                </div>
              </template>
            </Table>
          </div>
        </div>
        <div class="item" v-if="details.open === 1">
          <span class="label">报名表单：</span>
          <div class="content">
            <div v-for="item in details.signUps" :key="item.code">
              {{ item.value }} {{ item.must === 1 ? " - 必填" : "" }}
            </div>
          </div>
        </div>
      </div>
      <div class="drawer-content" v-if="isTab === 2">
        <Table :columns="personnelColumns" :data="personnelList">
          <template slot-scope="{ row }" slot="name">
            <strong>{{ JSON.parse(row.info)[0].content }}</strong>
          </template>
          <template slot-scope="{ row }" slot="phone">
            <strong>{{ JSON.parse(row.info)[1].content }}</strong>
          </template>
          <template slot-scope="{ row }" slot="check">
            <div style="cursor: pointer" @click="checkTab(row.signUpDtos)">
              查看
            </div>
          </template>
          <template slot-scope="{ row }" slot="status">
            <strong>{{ row.status === 1 ? "已报名" : "已取消" }}</strong>
          </template>
          <template slot-scope="{ row }" slot="cancel">
            <div
              v-if="row.status === 1"
              style="cursor: pointer"
              @click="cancelSign(row.id, row.meetingId)"
            >
              取消报名
            </div>
            <Poptip trigger="hover" content="已取消报名" v-else>
              <div style="cursor: no-drop; color: #bdbcbc">取消报名</div>
            </Poptip>
          </template>
        </Table>
      </div>
      <div class="drawer-content" v-if="isTab === 3">
        <div class="list-box">
          <div class="list-item" v-for="item in multimediaList" :key="item.id">
            <div class="item-img">
              <img :src="$global.imgUrl + item.url" alt="" />
              <div class="mask">
                <Icon
                  style="vertical-align: middle; cursor: pointer"
                  color="#fff"
                  size="26"
                  type="ios-eye-outline"
                  @click="imgPreview($global.imgUrl + item.url)"
                />
                |
                <Icon
                  style="vertical-align: middle; cursor: pointer"
                  color="#fff"
                  size="26"
                  type="ios-trash-outline"
                  @click="delImg(item.id, 1)"
                />
              </div>
            </div>
            <div class="item-status">
              <div>
                <span
                  class="state"
                  style="background-color: #1989fa"
                  v-if="item.auditStatus === 2"
                  >已发布</span
                >
                <span
                  class="state"
                  style="background-color: #ff9900"
                  v-else-if="item.auditStatus === 0"
                  >审核中</span
                >
                <span
                  class="state"
                  style="background-color: #ff0033"
                  v-else-if="item.auditStatus === 3"
                  >未通过</span
                >
                <Poptip
                  v-if="item.auditStatus === 3"
                  style="vertical-align: middle"
                  trigger="hover"
                  word-wrap 
                  width="300"
                  :content="item.reason"
                  placement="right"
                >
                  <Icon
                    color="#ff0033"
                    size="22"
                    type="ios-information-circle"
                    style="cursor: pointer"
                  />
                </Poptip>
              </div>
              <div
                v-if="item.auditStatus === 3"
                style="margin-right: 5px; cursor: pointer"
              >
                <Upload
                  :action="`${$global.uplodeUrl}zw-public/web/common/upload`"
                  :headers="{ token: token }"
                  :show-upload-list="false"
                  accept=".png,.jpg,.jpeg"
                  :format="['jpg', 'jpeg', 'png']"
                  :max-size="1024"
                  :on-exceeded-size="handleMaxSize"
                  :on-success="
                    (res, file) => {
                      openUpload(res, file, item.id);
                    }
                  "
                >
                  <Icon size="26" type="ios-create-outline" />
                </Upload>
              </div>
            </div>
            <div class="item-name">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="drawer-content" v-if="isTab === 4">
        <div class="list-box">
          <div class="list-item" v-for="item in multimediaList" :key="item.id">
            <div class="item-img">
              <video :src="$global.imgUrl + item.url"></video>
              <div class="mask">
                <Icon
                  style="vertical-align: middle; cursor: pointer"
                  color="#fff"
                  size="26"
                  type="ios-play"
                  @click="videoPreview($global.imgUrl + item.url)"
                />
                |
                <Icon
                  style="vertical-align: middle; cursor: pointer"
                  color="#fff"
                  size="26"
                  type="ios-trash-outline"
                  @click="delImg(item.id, 2)"
                />
              </div>
            </div>
            <div class="item-status">
              <div>
                <span
                  class="state"
                  style="background-color: #1989fa"
                  v-if="item.auditStatus === 2"
                  >已发布</span
                >
                <span
                  class="state"
                  style="background-color: #ff9900"
                  v-else-if="item.auditStatus === 0"
                  >审核中</span
                >
                <span
                  class="state"
                  style="background-color: #ff0033"
                  v-else-if="item.auditStatus === 3"
                  >未通过</span
                >
                <Poptip
                  v-if="item.auditStatus === 3"
                  style="vertical-align: middle"
                  trigger="hover"
                  word-wrap 
                  width="300"
                  :content="item.reason"
                  placement="right"
                >
                  <Icon
                    color="#ff0033"
                    size="22"
                    type="ios-information-circle"
                    style="cursor: pointer"
                  />
                </Poptip>
              </div>
              <div
                v-if="item.auditStatus === 3"
                style="margin-right: 5px; cursor: pointer"
              >
                <Upload
                  action=""
                  :headers="{ token: token }"
                  accept=".mp4,.avi"
                  :format="['mp4', 'avi']"
                  :show-upload-list="false"
                  :max-size="512000"
                  :before-upload="
                    (file) => {
                      openVModel(file, item.id);
                      return false;
                    }
                  "
                  :on-exceeded-size="handleMaxSize"
                >
                  <Icon size="26" type="ios-create-outline" />
                </Upload>
              </div>
            </div>
            <div class="item-name">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <Spin fix v-show="spinShow">
        <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
      </Spin>
    </div>
    <div style="text-align: center; margin-top: 20px">
      <Page
        v-if="isTab !== 1 && total > 10"
        :page-size="10"
        :total="total"
        :current="pageNo"
        @on-change="pageChange"
      />
    </div>
    <Modal v-model="registrationModal" :footer-hide="true">
      <RegistrationForm :arr="formArr" />
    </Modal>
    <!-- 上传图片/视频弹窗 -->
    <Modal
      width="572"
      v-model="UploadShow"
      footer-hide
      :mask-closable="false"
      @on-visible-change="modalChange"
    >
      <h3>{{ isTab === 3 ? "会议图片" : "会议视频" }}</h3>
      <div v-if="isTab === 3">
        <div class="img-upload-box">
          <Upload
            v-if="url === ''"
            :action="`${$global.uplodeUrl}zw-public/web/common/upload`"
            :headers="{ token: token }"
            :show-upload-list="false"
            accept=".png,.jpg,.jpeg"
            :format="['jpg', 'jpeg', 'png']"
            :max-size="1024"
            :on-exceeded-size="handleMaxSize"
            :on-success="
              (res, file) => {
                openUpload(res, file, uplodeId);
              }
            "
          >
            <div class="img-upload-item">
              <Icon type="ios-add" size="50" />
              <p class="text">请上传会议图片</p>
            </div>
          </Upload>
          <div class="img-upload-list" v-else>
            <img class="img" :src="$global.imgUrl + url" alt="" />
            <Input v-model="fileName" size="small" />
            <Icon
              class="img-upload-icon"
              type="ios-close-circle"
              size="16"
              @click="url = ''"
            />
          </div>
        </div>
        <div style="text-align: center">
          <Button
            type="primary"
            size="large"
            style="padding: 0 50px"
            @click="submitImgVideo"
            >提交</Button
          >
        </div>
      </div>
      <div v-else>
        <div class="progress-box">
          <div
            class="progress"
            style="display: flex; align-items: center"
            v-if="progressTotal > 0 && progressTotal < 100"
          >
            <Icon style="margin-right: 10px" type="ios-videocam" size="40" />
            <Progress
              style="flex: 1"
              v-if="progressTotal > 0 && progressTotal < 100"
              :percent="progressTotal"
              :stroke-width="8"
            />
            <span
              style="cursor: pointer"
              type="primary"
              v-if="progressTotal > 0 && progressTotal < 99"
              @click="handleBtn"
              >{{ btn | btnText }}</span
            >
          </div>
          <div style="display: flex; align-items: center">
            <span class="progress-title">标题：</span>
            <Input style="flex: 1" v-model="fileName" size="small" />
          </div>
        </div>
        <div style="text-align: center">
          <Button
            type="primary"
            size="large"
            style="padding: 0 50px"
            :disabled="progressTotal < 100"
            @click="submitImgVideo"
            >提交</Button
          >
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { imgPreview, videoPreview } from "@/utils/previewMethod.js";
import mixin from "@/mixins/continuingly";
import RegistrationForm from "./registrationForm.vue";

export default {
  props: ["id"],
  mixins: [mixin],
  created() {
    this.getEcho(this.id);
  },
  computed: {
    ...mapState(["token"]),
  },
  components: { RegistrationForm },
  data() {
    return {
      isTab: 1,
      registrationModal: false,
      details: {},
      tickeColumns: [
        {
          title: "票种",
          key: "ticketName",
        },
        {
          title: "票价（元）",
          key: "price",
        },
        {
          title: "票数（0标识不限制数量）",
          key: "quantity",
        },
        {
          title: "有效期",
          slot: "date",
        },
      ],
      personnelColumns: [
        {
          title: "参会人姓名",
          slot: "name",
        },
        {
          title: "电话",
          slot: "phone",
        },
        {
          title: "报名信息",
          slot: "check",
        },
        {
          title: "状态",
          slot: "status",
        },
        {
          title: "操作",
          slot: "cancel",
        },
      ],
      multimediaList: [],
      personnelList: [],
      formArr: [],
      uplodeId: "",
      UploadShow: false,
      total: 0,
      pageNo: 1,
      spinShow: false,
    };
  },
  methods: {
    imgPreview,
    videoPreview,
    // 删除图片/视频
    async delImg(id, type) {
      this.$Modal.confirm({
        title: "操作确认",
        content: `<p>是否删除${
          type === 1 ? "图片" : "视频"
        }?删除后无法恢复</p>`,
        onOk: async () => {
          const res = await this.$apis.userServe.delImgVideo({
            id,
          });
          if (res.resultCode === "200") {
            this.$Message.success("删除成功");
            await this.getImg(this.pageNo, type);
          }
        },
        onCancel: () => {
          this.$Message.info("已取消删除操作");
        },
      });
    },
    // 参会人员查看信息
    checkTab(arr) {
      this.registrationModal = true;
      console.log(arr, "arr");
      this.formArr = [...arr];
    },
    // 参会人员取消报名
    cancelSign(id, meetingId) {
      this.$Modal.confirm({
        title: "取消报名",
        content: "<p>是否确认取消用户的报名</p>",
        onOk: async () => {
          const res = await this.$apis.userServe.cancelSign({
            id,
            meetingId,
          });
          if (res.resultCode === "200") {
            this.$Message.success("取消成功");
            this.getPersonnel(this.pageNo);
          }
        },
        onCancel: () => {
          this.$Message.info("取消操作");
        },
      });
    },
    // 切换tab
    changeTab(tab) {
      switch (tab) {
        case 2:
          this.isTab = tab;
          this.getPersonnel(1);
          break;
        case 3:
          this.multimediaList = [];
          this.isTab = tab;
          this.getImg(1, 1);
          break;
        case 4:
          this.multimediaList = [];
          this.isTab = tab;
          this.getImg(1, 2);
          break;
      }
      this.total = 0;
    },
    // 获取详情
    async getEcho(id) {
      const resp = await this.$apis.userServe.getMeetingDetailById({ id });
      this.details = resp.data;
    },
    // 获取参会人员
    async getPersonnel(page) {
      this.spinShow = true;
      this.pageNo = page;
      let obj = {
        meetingId: this.id,
        pageNo: page,
        pageSize: 10,
      };
      const res = await this.$apis.userServe.getSignUpList(obj);
      this.personnelList = res.data.list;
      this.total = +res.data.total;
      this.spinShow = false;
    },
    // 获取视频/图片
    async getImg(page, type) {
      this.spinShow = true;
      this.pageNo = page;
      let obj = {
        meetingId: this.id,
        pageNo: page,
        pageSize: 12,
        type,
      };
      const res = await this.$apis.userServe.getMeetingImgList(obj);
      this.multimediaList = res.data.list;
      this.total = +res.data.total;
      this.spinShow = false;
    },
    // 分页
    pageChange(page) {
      if (this.isTab === 2) {
        this.getPersonnel(page);
      } else if (this.isTab === 3) {
        this.getImg(page, 1);
      } else {
        this.getImg(page, 2);
      }
    },

    // 图片上传并打开图片上传窗口
    openUpload(res, file, id) {
      this.uplodeId = id;
      this.UploadShow = true;
      this.url = file.response.content.url;
      this.fileName = file.name;
    },

    // 打开上传视频
    openVModel(file, id) {
      this.uplodeId = id;
      this.UploadShow = true;
      this.handleBefore(file)
        .then((res) => {})
        .catch((err) => {}); // catch 接受下handleBefore方法返回的promise报错
    },

    // 提交图片/视频
    async submitImgVideo() {
      const res = await this.$apis.userServe.updImgVideo({
        id: this.uplodeId,
        url: this.url,
        name: this.fileName,
      });
      if (res.resultCode === "200") {
        this.UploadShow = false;
        if (this.isTab === 3) {
          this.getImg(this.pageNo, 1);
        } else if (this.isTab === 4) {
          this.getImg(this.pageNo, 2);
        }
      }
    },
    // 上传视频/图片弹窗打开关闭
    modalChange(type) {
      if (!type) {
        this.uplodeId = "";
        this.url = "";
        this.progressTotal = 0;
        this.fileName = "";
      }
    },
    // 图片上传超过限制大小
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "图片/视频上传过大",
        desc: file.name + "该文件大小超过1M.",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.drawer-box {
  padding: 0 20px 20px;
  .title {
    font-size: 26px;
    font-weight: 400;
    color: #333333;
    line-height: 48px;
  }
  .release-box {
    margin: 10px 0 25px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #333333;
  }
  .column {
    display: flex;
    align-items: center;
    font-size: 18px;
    color: #3c3c3c;
    .tab {
      margin-right: 20px;
      cursor: pointer;
      &:last-child {
        margin-right: 0;
      }
    }
    .is-tab {
      color: #0b35c5;
    }
  }
  .drawer-content-box {
    position: relative;
    .demo-spin-icon-load {
      animation: ani-demo-spin 1s linear infinite;
    }
    &::v-deep .ivu-spin-fix {
      background-color: rgb(255 255 255);
    }
    .drawer-content {
      margin-top: 25px;
      .item {
        display: flex;
        margin-bottom: 10px;
        .label {
          margin-right: 15px;
          width: 85px;
          font-size: 14px;
          font-weight: bold;
          color: #333333;
          line-height: 30px;
        }
        .content {
          flex: 1;
          font-size: 14px;
          color: #000000;
          line-height: 30px;
          .file-name {
            display: inline-block;
            max-width: 300px;
          }
          .file-btn {
            color: #152ead;
            cursor: pointer;
          }
          &::v-deep img,
          &::v-deep video {
            max-width: 100% !important;
          }
          &::v-deep span {
            white-space: normal !important;
          }
          .committee {
            display: flex;
            margin-bottom: 50px;
            color: #333333;
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
        .more-auther {
          &::after {
            content: "，";
          }
          &:last-child {
            &::after {
              content: "";
            }
          }
        }
        .content-img {
          width: 86px;
          height: 100px;
        }
      }
      .list-box {
        display: flex;
        flex-wrap: wrap;
        .list-item {
          margin-right: 20px;
          margin-bottom: 25px;
          width: 250px;
          &:nth-child(4n) {
            margin-right: 0;
          }
          .item-img {
            position: relative;
            width: 100%;
            height: 150px;
            img {
              width: 100%;
              height: 100%;
            }
            video {
              width: 100%;
              height: 100%;
            }
            .mask {
              display: none;
              position: absolute;
              background: rgba(61, 60, 60, 0.779);
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              line-height: 150px;
              text-align: center;
              color: #fff;
            }
            &:hover .mask {
              display: block;
            }
          }
          .item-status {
            display: flex;
            justify-content: space-between;
            margin: 5px 0;
            height: 30px;
            .state {
              display: inline-block;
              margin-right: 5px;
              padding: 2px 5px;
              text-align: center;
              color: #fff;
              border-radius: 5px;
            }
          }
          .item-name {
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}

.img-upload-box {
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
  .img-upload-list {
    position: relative;
    margin: 0 10px 20px;
    width: 160px;
    .img {
      width: 100%;
      height: 160px;
      border: 1px solid #999;
      border-radius: 5px;
    }
    .img-name {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .img-upload-icon {
      position: absolute;
      top: -8px;
      right: -8px;
      cursor: pointer;
    }
  }
  .img-upload-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0 10px;
    width: 160px;
    height: 160px;
    color: #1989fa;
    text-align: center;
    border: 1px dashed #e4e4e4;
    border-radius: 5px;
    .plus {
      font-size: 50px;
    }
  }
}
.progress-box {
  margin: 20px 0;
  .progress {
    margin-bottom: 10px;
    padding: 10px;
    border: 1px solid #d7d7d7;
    border-radius: 5px;
  }
  .progress-title {
    font-size: 18px;
  }
}
</style>